import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const Label = styled.label`
    ${BaseStyle.Mixins.fontStyles.ui['12m']};
    color: ${({ theme }) => theme.Text.secondary};
    display: block;
    text-transform: uppercase;
`;

export default Label;
